import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import s from './Input.scss';

class Input extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    type: PropTypes.oneOf(['text', 'password', 'search']),
    className: PropTypes.string,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.string,
    autoFocus: PropTypes.bool,
    hbus: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    rfk: PropTypes.string,
  };

  shouldComponentUpdate(nextProps, nextState) {
    const {
      value,
    } = this.props;

    return nextProps.value !== value;
  }

  render() {
    const {
      className,
      otherClassName,
      hbus,
      rfk,
      placeholder,
      type,
      value,
      onKeyUp,
      onKeyDown,
      onBlur,
      onFocus,
      onChange,
      autoFocus,
    } = this.props;

    return (
      <input
        className={cx(s.hbInput, s[className], otherClassName)}
        data-hbus={hbus}
        data-rfkid={rfk}
        placeholder={placeholder}
        type={type}
        value={value ? value : ''}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={autoFocus}/>
    );
  }
}

export default Input;
